/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Plus = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.375 12C21.375 12.2984 21.2565 12.5845 21.0455 12.7955C20.8345 13.0065 20.5484 13.125 20.25 13.125H13.125V20.25C13.125 20.5484 13.0065 20.8345 12.7955 21.0455C12.5845 21.2565 12.2984 21.375 12 21.375C11.7016 21.375 11.4155 21.2565 11.2045 21.0455C10.9935 20.8345 10.875 20.5484 10.875 20.25V13.125H3.75C3.45163 13.125 3.16548 13.0065 2.9545 12.7955C2.74353 12.5845 2.625 12.2984 2.625 12C2.625 11.7016 2.74353 11.4155 2.9545 11.2045C3.16548 10.9935 3.45163 10.875 3.75 10.875H10.875V3.75C10.875 3.45163 10.9935 3.16548 11.2045 2.9545C11.4155 2.74353 11.7016 2.625 12 2.625C12.2984 2.625 12.5845 2.74353 12.7955 2.9545C13.0065 3.16548 13.125 3.45163 13.125 3.75V10.875H20.25C20.5484 10.875 20.8345 10.9935 21.0455 11.2045C21.2565 11.4155 21.375 11.7016 21.375 12Z"
          fill="#002967"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4701_35809)">
        <path
          d="M16 8C16 8.25461 15.8989 8.49879 15.7188 8.67882C15.5388 8.85886 15.2946 8.96 15.04 8.96H8.96V15.04C8.96 15.2946 8.85886 15.5388 8.67882 15.7188C8.49879 15.8989 8.25461 16 8 16C7.74539 16 7.50121 15.8989 7.32118 15.7188C7.14114 15.5388 7.04 15.2946 7.04 15.04V8.96H0.96C0.705392 8.96 0.461212 8.85886 0.281178 8.67882C0.101143 8.49879 0 8.25461 0 8C0 7.74539 0.101143 7.50121 0.281178 7.32118C0.461212 7.14114 0.705392 7.04 0.96 7.04H7.04V0.96C7.04 0.705392 7.14114 0.461212 7.32118 0.281178C7.50121 0.101143 7.74539 0 8 0C8.25461 0 8.49879 0.101143 8.67882 0.281178C8.85886 0.461212 8.96 0.705392 8.96 0.96V7.04H15.04C15.2946 7.04 15.5388 7.14114 15.7188 7.32118C15.8989 7.50121 16 7.74539 16 8Z"
          fill="#002967"
        />
      </g>
      <defs>
        <clipPath id="clip0_4701_35809">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Plus;
